import { useEffect, useState } from 'react';
import { consumeCookieSettingsRequest, subscribeCookieConsent } from '@/lib/cookieConsent';
import { useCookieConsent } from '@/hooks/useCookieConsent';

export function CookieConsentBanner() {
  const { consent, accept, deny } = useCookieConsent();
  const [open, setOpen] = useState(consent === null);

  useEffect(() => {
    return subscribeCookieConsent(() => {
      if (consumeCookieSettingsRequest()) setOpen(true);
    });
  }, []);

  useEffect(() => {
    if (consent === null) setOpen(true);
  }, [consent]);

  if (!open) return null;

  const choose = (decision: 'accepted' | 'denied') => {
    if (decision === 'accepted') accept();
    else deny();
    setOpen(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[80] p-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
      <div className="mx-auto max-w-3xl rounded-2xl border border-white/15 bg-secondary-600/95 p-5 shadow-2xl backdrop-blur">
        <p className="text-white font-medium mb-2">Cookies on GayPHX</p>
        <p className="text-gray-300 text-sm leading-relaxed mb-4">
          Analytics and ads stay off until you allow them. If you deny, we do not load those cookies.
          Sign-in and the 18+ confirmation still work either way.
        </p>
        <div className="flex flex-col sm:flex-row gap-2">
          <button
            type="button"
            onClick={() => choose('denied')}
            className="min-h-11 px-4 rounded-lg border border-white/20 text-white hover:bg-white/10"
          >
            Deny
          </button>
          <button
            type="button"
            onClick={() => choose('accepted')}
            className="min-h-11 px-4 rounded-lg bg-primary text-white font-medium hover:bg-primary/90"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
